/**
 * production.ts — smelting raw ore on the focused layer into ingots, which are
 * worth a multiple of the raw value.
 */
import type { GameState } from '../core/GameState';
import { safeNumber } from '../core/numbers';
import type { Derived } from './derived';

export function tickSmelting(state: GameState, dtMs: number, d: Derived): void {
  if (d.smeltRate <= 0) return;
  const oreId = d.focusOreId;
  const want = safeNumber(d.smeltRate * (dtMs / 1000));
  const available = state.mining.ore[oreId] ?? 0;
  // Limited by available raw ore and by ingot storage capacity.
  const ingotsNow = state.mining.ingots[oreId] ?? 0;
  const spaceForIngots = Math.max(0, d.storage - ingotsNow);
  const processed = Math.min(want, available, spaceForIngots);
  if (processed <= 0) return;
  state.mining.ore[oreId] = available - processed;
  state.mining.ingots[oreId] = ingotsNow + processed;
}
